import { Link } from "react-router-dom";
import { Shield, Lock } from "lucide-react";
import { cn } from "@/lib/utils";

// Compact trust signal for footer / headers. Links to the dedicated /trust page.
// Designed to be subtle — not a bright banner. Editorial credential-style.
export default function TrustBadge({ className, variant = "default" }) {
    const content = (
        <>
            <Lock className="w-3.5 h-3.5 text-accent-bright" strokeWidth={1.5} aria-hidden="true" />
            <span className="text-[11px] uppercase tracking-[0.18em] font-medium">
                Privacy-first
            </span>
            <span className="w-1 h-1 rounded-full bg-current opacity-30" aria-hidden="true" />
            <Shield className="w-3.5 h-3.5 text-accent-bright" strokeWidth={1.5} aria-hidden="true" />
            <span className="text-[11px] uppercase tracking-[0.18em] font-medium">
                Ad-fraud protected
            </span>
        </>
    );

    const base = "inline-flex items-center gap-2 rounded-full border px-3.5 py-1.5 transition-colors";
    const styles = {
        default: "border-border bg-card text-primary hover:border-primary/30",
        dark: "border-primary-foreground/20 bg-transparent text-primary-foreground hover:border-primary-foreground/40",
    };

    return (
        <Link
            to="/trust"
            data-testid="trust-badge"
            className={cn(base, styles[variant] ?? styles.default, className)}
            aria-label="Learn more about FinCalc's privacy and ad-fraud protection"
        >
            {content}
        </Link>
    );
}
